<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="narcoticsbox-record-list"
            :url="url"
            :columns="columnList"
            :buttons="[]"
            dialogWidth="65%"
            class="form-table-h360"
            :addButton="{ enabled: false, permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default' }"
            @loadingDetailView="loadingDetailView"
            @printDetail="printDetail"
        >
            <slot slot="filter">
                <el-col :md="8" :xl="4" class="align-left">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
            </slot>
            <slot slot="filter-after">
                <el-button type="primary" size="mini" @click="ExportExcel">导出</el-button>
            </slot>
        </crud-facecade>
        <el-dialog title="使用详情" width="90%" class="form-table-h360" :visible.sync="returnee.dialogFormVisible" :close-on-click-modal="false">
            <CusStep :steps="transportNode">
                <div slot-scope="{ step, index }">
                    <div v-if="index == 0">{{ step.preparator || '--' }}&nbsp;&nbsp;备药</div>
                    <div v-if="index == 1">
                        <div>{{ step.receiver || '--' }}&nbsp;&nbsp;领药</div>
                        <div>{{ step.register || '--' }}&nbsp;&nbsp;发放</div>
                    </div>
                    <div v-if="index == 2">
                        <div>{{ step.returnee || '--' }}&nbsp;&nbsp;归还</div>
                        <div>{{ step.verifier || '--' }}&nbsp;&nbsp;核对</div>
                    </div>
                </div>
            </CusStep>
            <cus-form :columns="returnColumns" :data="returnee.data"></cus-form>
        </el-dialog>
    </div>
</template>
<script>
import SaveAs from './SaveAs.vue'
export default {
    name: `NarcoticsBoxTrace`,
    props: {

    },
    components: { SaveAs },
    data() {
        return {
            title: `使用追踪`,
            returnee: {
                dialogFormVisible: false,
                record: {},
                data: {}
            },
            rdate: [this.$moment().add(-3, `days`).format(`YYYY/MM/DD`), this.$moment().format(`YYYY/MM/DD`)],
            url: { area: `NarcoticsBoxTrace`,
                baseURL: `/api/Intraoperative/NarcoticsBoxTrace/Records`,
                get: () => {
                    return this.loadNarcoticsBoxRecord()
                } }
        }
    },
    created() {
        // this.$store.dispatch("ADD_WARD_AUTH")
    },
    computed: {
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                isListable: false,
                isKey: true
            }, {
                type: `string`,
                prop: `code`,
                label: `编号`,
                isListable: true
            }, {
                type: `string`,
                prop: `name`,
                label: `药箱名称`,
                isListable: true
            }, {
                type: `datetime`,
                prop: `receive_date`,
                label: `领用时间`,
                isListable: true
            }, {
                type: `string`,
                prop: `receiver`,
                label: `领用者`,
                isListable: true
            }, {
                type: `string`,
                prop: `register`,
                label: `领用登记人`,
                isListable: true
            }, {
                type: `datetime`,
                prop: `return_date`,
                label: `归还时间`,
                isListable: true
            }, {
                type: `string`,
                prop: `returnee`,
                label: `归还者`,
                isListable: true
            }, {
                type: `string`,
                prop: `verifier`,
                label: `归还登记人`,
                isListable: true
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `260`,
                isListable: true,
                readonly: false,
                options: [{
                    class: `is-plain`,
                    label: `查看`,
                    icon: ``,
                    type: `primary`,
                    emit: `loadingDetailView`,
                    permission: `default`
                }, {
                    class: `is-plain`,
                    label: `打印清单`,
                    icon: ``,
                    type: `primary`,
                    emit: `printDetail`,
                    permission: `default`
                }]
            }]
        },
        returnColumns() {
            return [{
                type: `table2`,
                prop: `items`,
                label: `药品清单`,
                spanMethod: this.objectSpanMethod,
                isEditable: true,
                isCreatable: true,
                options: [{
                    type: `string`,
                    prop: `id`,
                    label: `id`,
                    isKey: true
                }, {
                    type: `string`,
                    prop: `dic_drug`,
                    label: `药品`,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `batch_number`,
                    label: `批号`,
                    width: `100`,
                    isListable: true
                }, {
                    type: `integer`,
                    prop: `amount`,
                    label: `基数`,
                    width: `80`,
                    isListable: true
                }, {
                    type: `integer`,
                    prop: `amount_dosage`,
                    label: `基数总量`,
                    width: `100`,
                    isListable: true
                }, {
                    type: `integer`,
                    prop: `use_amount`,
                    label: `空安瓿数`,
                    width: `100`,
                    isListable: true
                }, {
                    type: `integer`,
                    prop: `remain_amount`,
                    label: `剩余安瓿`,
                    width: `100`,
                    isListable: true
                }, {
                    type: `integer`,
                    prop: `use_dose`,
                    label: `总用量`,
                    width: `100`,
                    isListable: true
                }, {
                    type: `integer`,
                    prop: `destruction_dose`,
                    label: `销毁总量`,
                    width: `100`,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `patient_name`,
                    label: `患者姓名`,
                    isListable: true
                }, {
                    type: `integer`,
                    prop: `surgery_use_amount`,
                    label: `使用数量`,
                    isListable: true
                }],
                colspan: 24,
                default: []
            }]
        },
        transportNode() {
            let r = []
            r.push({
                title: `备药`,
                status: this.returnee.record.prepare_date ? `primary` : `info`,
                occur_time: this.returnee.record.prepare_date,
                preparator: this.returnee.record.preparator
            })
            r.push({
                title: `领药`,
                status: this.returnee.record.receive_date ? `primary` : `info`,
                occur_time: this.returnee.record.receive_date,
                receiver: this.returnee.record.receiver,
                register: this.returnee.record.register
            })
            r.push({
                title: `归还`,
                status: this.returnee.record.return_date ? `primary` : `info`,
                occur_time: this.returnee.record.return_date,
                returnee: this.returnee.record.returnee,
                verifier: this.returnee.record.verifier
            })
            return r
        }
    },
    methods: {
        ExportExcel() {
            this.myaxios.get(`/api/Intraoperative/NarcoticsBoxTrace/GetRecordsForExport?from=${this.rdate[0]}&to=${this.$moment(this.rdate[1]).add(1, `days`).format(`YYYY/MM/DD`)}`).then(data => {
                if (data.length <= 0) {
                    this.$message.warning(`暂无导出数据`)
                    return
                }
                this.myaxios.export_excel(data, `毒麻药箱使用追踪.xls`)
            })
        },
        loadNarcoticsBoxRecord() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/Intraoperative/NarcoticsBoxTrace/Records?begin=${this.rdate[0]}&end=${this.$moment(this.rdate[1]).add(1, `days`).format(`YYYY/MM/DD`)}`)
                req.then(data => {
                    let r = data && data.map(d => {
                        d.name = d.box.name
                        d.code = d.box.code
                        return d
                    })
                    resolve(r)
                }).catch(e => reject(e))
            })
        },
        ReloadListData() {
            let that = this
            that.$refs[`narcoticsbox-record-list`].ReloadListData()
        },
        loadingDetailView({ row }) {
            let that = this
            let r = { ...row }
            this.returnee.record = { ...row }
            let req
            if (r.id >= 0) {
                req = this.myaxios.get(`/api/Intraoperative/NarcoticsBoxTrace/Drugs/${r.id}`)
            } else {
                req = Promise.resolve([])
            }
            req.then(data => {
                // r.items = data && data.map((d, index) => {
                //     let r = {}
                //     r.index = index
                //     r.id = d.id
                //     r.dic_drug = d.drug.name
                //     r.spec = d.drug.spec
                //     r.unit = d.drug.drug_unit
                //     r.batch_number = d.batch_number
                //     r.amount = d.amount || undefined
                //     r.amount_dosage = d.amount * d.drug.dose || undefined
                //     r.dosa = d.drug.dose || undefined
                //     r.use_amount = d.use_amount || undefined
                //     r.remain_amount = d.remain_amount || undefined
                //     r.use_dose = d.use_dose || undefined
                //     r.destruction_dose = d.destruction_dose || undefined

                //     r.patient_name = d.patient_name
                //     r.surgery_use_amount = d.surgery_use_amount
                //     r.surgery_use_dose = d.surgery_use_dose
                //     r.surgery_destruction_dose = d.surgery_destruction_dose
                //     r.useDrugCount = d.useDrugCount || 0
                //     return r
                // })

                that.dataList = []
                let groupId = _.groupBy(data, `id`)
                _.forEach(groupId, (group, index) => {
                    _.forEach(group, (item, cindex) => {
                        that.dataList.push({
                            index: cindex,
                            id: item.id,
                            dic_drug: item.drug.name,
                            spec: item.drug.spec,
                            unit: item.drug.drug_unit,
                            batch_number: item.batch_number,
                            amount: item.amount || 0,
                            amount_dosage: item.amount * item.drug.dose || 0,
                            dosa: item.drug.dose || 0,
                            use_amount: item.use_amount || 0,
                            remain_amount: item.remain_amount || 0,
                            use_dose: item.use_dose || 0,
                            destruction_dose: item.destruction_dose || 0,

                            patient_name: item.patient_name,
                            surgery_use_amount: item.surgery_use_amount,
                            surgery_use_dose: item.surgery_use_dose,
                            surgery_destruction_dose: item.surgery_destruction_dose,
                            useDrugCount: item.useDrugCount || 0,
                            length: group.length
                        })
                    })
                })
                r.items = that.dataList
                console.log(`that.dataList`, that.dataList)

                console.log(r)
                this.returnee.data = r
                this.returnee.dialogFormVisible = true
            })
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex > 0 && columnIndex < 10) {
                if (row.index == 0 && row.length > 0) {
                    return [row.length, 1]
                } else if (row.index == 0 && row.length == 2) {
                    return [1, 1]
                } else {
                    return [0, 0]
                }
            }
        },
        printDetail({ row }) {
            this.$store.dispatch(`PRINT_PDF`, { host: this.$root.DOCSERVICE_BASE,
                params: {
                    docid: this.$root.DOCUMENT.CFD021,
                    id1: ``,
                    objId: row.id
                } })
        },
        confirm() {
            this.returnee.dialogFormVisible = false
        }
    },
    watch: {
        rdate: function() {
            this.ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/NarcoticsBox/Trace.vue